// Function to check if any part of an element is in the viewport, with a distance from the bottom
function isPartiallyInViewport(el: HTMLElement) {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop <=
    (window.innerHeight || document.documentElement.clientHeight) / 1
  );
}

// Function to handle scroll events
function handleScroll() {
  const animatedElements = document.querySelectorAll('section');

  animatedElements.forEach((element) => {
    if (isPartiallyInViewport(element)) {
      element.classList.add('visible');
    }
  });
}

// Initial check on page load
document.addEventListener('DOMContentLoaded', function () {
  handleScroll();
});

// Attach the handleScroll function to the scroll event
window.addEventListener('scroll', handleScroll);